import { MenuItem } from 'shared';

import { useAddGoalFocusArea } from 'features/goal';

export const GoalBreakdownMenuAddButton = () => {
  const { onAddFocusAreaClick } = useAddGoalFocusArea();

  return <MenuItem onClick={onAddFocusAreaClick}>Focus area</MenuItem>;
};
